import React from 'react'
import { Badge } from 'antd'
import { APIError } from '../../services/api/client/types'

type Props = {
  failedOrders: number
  isLoading: boolean
  error: APIError | null
}

export const View: React.FunctionComponent<Props> = ({
  children,
  failedOrders,
  isLoading,
  error,
}) => {
  if (isLoading || error) {
    return <>{children}</>
  }

  return (
    <Badge size="small" count={failedOrders}>
      {children}
    </Badge>
  )
}
